import { db } from '../firebase'
import { doc, onSnapshot } from 'firebase/firestore';
import { setRider } from '../features/selectedRiderSlice';
import { useDispatch } from 'react-redux';
import { useEffect } from 'react';

const RIDER_SHASHI_ID = '3el1sDzRWWUAD8fr0vAP9E9vFZf2';

const useRider = () => {
  const dispatch = useDispatch();
  useEffect(() => {
    // console.log(`Setting up rider subscription for: ${RIDER_SHASHI_ID}`);

    const riderRef = doc(db, `/users/${RIDER_SHASHI_ID}`)
  
    const riderUnsubscribe = onSnapshot(riderRef, riderSnapshot => {
      const {latestRide, featuredTour, ...riderDoc} = riderSnapshot.data();

      dispatch(setRider({
        ...riderDoc, 
        uid: riderSnapshot.id, 
        latestRideId: latestRide?.id, 
        featuredTourId: featuredTour?.id
      }));
    });

    return () => {
      // console.log('Unsubscribing rider');
      riderUnsubscribe();
    }
  }, [dispatch])
}

export default useRider;